import { Link, NavLink } from "react-router-dom";
import { ArrowLeft, LayoutDashboard, Receipt, ScrollText, ShieldCheck, TriangleAlert, Users } from "lucide-react";
import { BrynLogo } from "@/components/BrynLogo";
import { useStaff } from "@/lib/staff";

const NAV = [
  { to: "/staff", end: true, icon: LayoutDashboard, label: "Overview", perm: "dashboard", testid: "staff-nav-overview" },
  { to: "/staff/students", icon: Users, label: "Students", perm: "students.view", testid: "staff-nav-students" },
  { to: "/staff/billing", icon: Receipt, label: "Usage & Billing", perm: "billing.view", testid: "staff-nav-billing" },
  { to: "/staff/errors", icon: TriangleAlert, label: "Errors", perm: "errors.view", testid: "staff-nav-errors" },
  { to: "/staff/team", icon: ShieldCheck, label: "Staff & Access", perm: "staff.manage", testid: "staff-nav-team" },
  { to: "/staff/audit", icon: ScrollText, label: "Audit log", perm: "audit.view", testid: "staff-nav-audit" },
];

const item = ({ isActive }) => `flex items-center gap-2.5 h-9 px-3 rounded-lg text-sm transition-colors outline-none focus-visible:ring-2 focus-visible:ring-sky-400/70 ${
  isActive ? "bg-sky-400/15 text-white" : "text-neutral-400 hover:text-white hover:bg-white/[0.04]"}`;

export function StaffSidebar({ onPick }) {
  const { can } = useStaff();
  return (
    <div className="h-full w-full flex flex-col bg-[#0C1322] border-r border-[#1B2740]" data-testid="staff-sidebar">
      <div className="h-14 shrink-0 flex items-center gap-2 px-4">
        <BrynLogo markClass="h-7 w-7" />
        <span className="text-[10px] uppercase tracking-[0.18em] text-sky-300/80 mt-0.5">Staff</span>
      </div>
      <nav className="px-2 mt-2 space-y-0.5" aria-label="Staff">
        {NAV.filter((n) => can(n.perm)).map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} onClick={onPick} className={item} data-testid={n.testid}>
            <n.icon className="h-[18px] w-[18px] stroke-[1.6] shrink-0" />{n.label}
          </NavLink>
        ))}
      </nav>
      <div className="mt-auto p-3">
        <Link to="/app" className="flex items-center gap-2 h-9 px-3 rounded-lg text-sm text-neutral-400 hover:text-white hover:bg-white/[0.04] transition-colors" data-testid="staff-back-to-app">
          <ArrowLeft className="h-4 w-4" />Back to BrynAI
        </Link>
      </div>
    </div>
  );
}
